import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import * as React from "react";

// This component's logic has been moved to ProductDetailsPage.trySetMetadata() for server-side rendering
const CENCustomProductNoIndex: React.FC = () => {
    return null;
};

const definition: WidgetDefinition = {
    group: "Basic",
    displayName: "Custom Product No Index",
};

const widgetModule: WidgetModule = {
    component: CENCustomProductNoIndex,
    definition,
};

export default widgetModule;